module.exports = require('./lib/client');